export const COPY_BATCH_DIALOG_LEGEND_ITEMS = [
  ["retained", "Unchanged"],
  ["added", "Newly Added"],
  ["kept", "Not Available in New Template"],
  ["moved", "Moved"],
  ["metadata_changed", "Metadata Changed"],
];

export const COPY_HISTORY_TABLE_COLUMNS = [
  { label: "Sr No.", width: "7%" },
  { label: "Batch ID", width: "20%" },
  { label: "Version", width: "12%" },
  { label: "Template Version", width: "15%" },
  { label: "Status", width: "12%" },
  { label: "Copied By", width: "16%" },
  { label: "Copied On", width: "18%" },
];







export const TEMPLATE_CHANGE_SUMMARY_TOOLTIP_SUMMARY_FIELDS = [
  ["added_tabs", "Added Tabs"],
  ["removed_tabs_retained", "Removed Tabs Retained"],
  ["added_columns", "Added Columns"],
  ["removed_columns_retained", "Removed Columns Retained"],
  ["removed_columns", "Removed Columns"],
  ["moved_columns", "Moved Columns"],
  ["unchanged_columns", "Unchanged Columns"],
];

export const CURRENT_TEMPLATE_VERSION_LABEL = "Current Template Version";
export const COPY_BATCH_TEMPLATE_VERSION_LABEL = "Version";
export const DERIVED_PARAMETER_CHANGE_SUMMARY = [
  { key: "added", label: "Added", color: "success" },
  { key: "updated", label: "Updated", color: "warning" },
  { key: "removed", label: "Removed", color: "error" },
];
export const DERIVED_PARAMETER_CHANGE_TYPE_LABELS = {
  added: "Added",
  formula_updated: "Formula Updated",
  removed: "Removed",
};
export const RETAINED_SHEET_LABEL = "Retained sheet";
export const RETAINED_SHEET_MESSAGE =
  "This sheet is no longer part of the current template and is retained for historical reference only. No operations can be performed on this sheet.";
